<template>
  <div class="page-component-wrapper">
    <grid
      :config="gridConfig"
    >
    </grid>
  </div>
</template>

<script>
import gridConfig from './GridConfig.js'

export default {
  name: 'StocksParts',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  props: {
    poStillOpen: { type: Boolean, required: true }
  },
  computed: {
    gridConfig () {
      return gridConfig({ poStillOpen: this.poStillOpen })
    }
  }
}
</script>
